
        'use strict';

        import { Component, Inject, Input} from 'ng-metadata/core';
		import {FacetService} from '../../facet/facet.service';
		import {SearchService} from '../../search.service';
        import {PnxUtil} from '../../../nddUtils/pnxUtil.service';
        import {ResultUtil} from '../../../nddUtils/resultUtil.service';
        import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
        import {SearchFieldsService} from '../../search.fields.service';
        import {ConfigurationUtil} from  '../../../nddUtils/configurationUtil.service';

        const flatten = require('lodash/flatten');
        const he= require('he');

        @Component({
            selector: 'prm-search-result-frbr-line',
            templateUrl: 'components/search/searchResult/searchResultFrbr/searchResultFrbrLine.html'
        })


       export  class PrmSearchResultFrbrLine {

            @Input() isFullView: boolean;
            @Input() result;
            @Input() index;

            constructor(private searchService: SearchService,
                        private facetService: FacetService,
                        private searchFieldsService: SearchFieldsService,
                        private configurationUtil:ConfigurationUtil,
                        private pnxUtil : PnxUtil,
                        private resultUtil: ResultUtil,
                        @Inject('searchResultsIcons') private searchResultsIcons,
                        private primolyticsService: PrimolyticsService,
                        @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                        @Inject('$stateParams') private $state: ng.ui.IStateService,
                        @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService) {
            }

            @beacon({'p':'refine', 'op':'frbr','item':'result'})
            getFrbrRecords(){
                let facetString= 'frbrgroupid' + ','+'include'+','+this.pnxUtil.getValue(this.result, 'facets', 'frbrgroupid');
                let recTitle = this.pnxUtil.getValue(this.result, 'display', 'title');
                this.facetService.frbrSearch({facet: facetString, title: recTitle}, this.index);
                this.$mdDialog.hide(); //this is done in order to close the full view dialog in case the frbr is selected from it
            }

            getPlaceHolders() {
                let val = this.pnxUtil.getValue(this.result, 'display', 'version');

                return {idx_0:`<span class="best-location-organization">${val}</span>`};

            }

            isPc(){
                return this.result.context === 'PC';
            }

             isFrbrGeneric(){
                return this.resultUtil.isFrbr(this.result) && this.searchService.getFrbrDisplay() === 1 ;  //Generic Record
            }

        }



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultFrbr/searchResultFrbrLine.directive.ts